import { useCallback, useEffect, useState } from 'react'
import { User, UserParams } from 'src/domain/User/UserDomain'
import { useChangeProfile } from 'src/hooks/api/user/mutations/useChangeProfile'
import { toast } from 'react-toastify'

interface UseProfileProps {
  userId: string
  userList: User[]
  reset: (data: UserParams) => void
}

export const useProfile = ({ userId, userList, reset }: UseProfileProps) => {
  const [isOpenChangePasswordModal, setIsOpenChangePasswordModal] = useState(false)
  const { mutateAsync: changeProfile, isPending } = useChangeProfile()

  const handleOpenPopup = useCallback(() => {
    setIsOpenChangePasswordModal(true)
  }, [])

  const handleClosePopup = useCallback(() => {
    setIsOpenChangePasswordModal(false)
  }, [])

  const onSubmit = useCallback(
    async (formData: UserParams) => {
      const userDataFormatted = new User(formData)

      try {
        const userDataUpdated = await changeProfile(userDataFormatted)

        reset(userDataUpdated)
        toast.success('Perfil atualizado com sucesso')
      } catch (error) {
        console.error('Erro ao atualizar perfil:', error)
      }
    },
    [changeProfile]
  )

  useEffect(() => {
    const userData = userList?.find((user) => user.id === userId)
    if (userData) {
      reset(userData)
    }
  }, [userList, userId, reset])

  return { handleOpenPopup, handleClosePopup, isOpenChangePasswordModal, onSubmit, isSaving: isPending }
}
